import { render, staticRenderFns } from "./VerifyResultTable.vue?vue&type=template&id=dca86156&scoped=true&"
import script from "./VerifyResultTable.vue?vue&type=script&lang=js&"
export * from "./VerifyResultTable.vue?vue&type=script&lang=js&"
import style0 from "./VerifyResultTable.vue?vue&type=style&index=0&id=dca86156&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dca86156",
  null
  
)

export default component.exports